import { BugsDropdown } from './BugsDropdown';

export default BugsDropdown;
